module.exports = __webpack_public_path__ + "img/oganesian_500.5d79e8e5.jpg";